module.exports = __webpack_public_path__ + "img/checkered.12c48804.png";